
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ReferralsOverviewPanelProps {
  totalReferrals: number;
  pendingReferrals: number;
  approvedReferrals: number;
  completedReferrals: number;
}

const ReferralsOverviewPanel: React.FC<ReferralsOverviewPanelProps> = ({
  totalReferrals,
  pendingReferrals,
  approvedReferrals,
  completedReferrals
}) => {
  // Calculate percentages for the progress bars
  const pendingPercentage = (pendingReferrals / totalReferrals) * 100;
  const approvedPercentage = (approvedReferrals / totalReferrals) * 100;
  const completedPercentage = (completedReferrals / totalReferrals) * 100;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Referrals Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">Pending ({pendingReferrals})</span>
              <span className="text-sm text-gray-500">{pendingPercentage.toFixed(0)}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-yellow-400 h-2 rounded-full" 
                style={{ width: `${pendingPercentage}%` }}
              ></div>
            </div>
          </div>
          
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">Approved ({approvedReferrals})</span>
              <span className="text-sm text-gray-500">{approvedPercentage.toFixed(0)}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-500 h-2 rounded-full" 
                style={{ width: `${approvedPercentage}%` }}
              ></div>
            </div>
          </div>
          
          <div>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium">Completed ({completedReferrals})</span>
              <span className="text-sm text-gray-500">{completedPercentage.toFixed(0)}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-green-500 h-2 rounded-full" 
                style={{ width: `${completedPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 flex justify-between text-center">
          <div>
            <div className="text-xl font-bold">{totalReferrals}</div>
            <div className="text-xs text-gray-500">Total</div>
          </div>
          <div>
            <div className="text-xl font-bold text-yellow-500">{pendingReferrals}</div>
            <div className="text-xs text-gray-500">Pending</div>
          </div>
          <div>
            <div className="text-xl font-bold text-blue-500">{approvedReferrals}</div>
            <div className="text-xs text-gray-500">Approved</div>
          </div>
          <div>
            <div className="text-xl font-bold text-green-500">{completedReferrals}</div>
            <div className="text-xs text-gray-500">Completed</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralsOverviewPanel;
